module.exports = __webpack_public_path__ + "static/img/defaultShopImg.e407cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/image/defaultShopImg.png
// module id = +9Lz
// module chunks = 1